import React from 'react'

function Privacy() {
  return (
    <>
    <head>
    <meta charset="UTF-8"/>
    <meta name="viewport" content="width=device-width, initial-scale=1.0"/>
    <title>Privacy Policy</title>
    <link rel="stylesheet" href="<%= process.env.APP_URL %>/css/main.css"/>
    <link rel="preconnect" href="https://fonts.googleapis.com"/>
    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin/>
    <link href="https://fonts.googleapis.com/css2?family=K2D:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800&display=swap" rel="stylesheet"/>
    <link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@24,400,0,0" />
   
     <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css" rel="stylesheet" integrity="sha384-EVSTQN3/azprG1Anm3QDgpJLIm9Nao0Yz1ztcQTwFspd3yD65VohhpuuCOmLASjC" crossorigin="anonymous"/>
     <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/js/bootstrap.bundle.min.js" integrity="sha384-MrcW6ZMFYlzcLA8Nl+NtUVF0sA7MsXsP1UyJoMp4YLEuNSfAP+JcXn/tWtIaxVXM" crossorigin="anonymous"></script>
    </head>
    <body>
   
    <main>
        <section class="wrapper-body mt-4">
            
                <div class="container">
                    <div class="row wrapper-container mb-4">
                        <div class="col-12">
                            <div class="card">
                                <div class="card-body">
                                    
                                    <div class="head_Info my-3">
                                       
                                        <p>This policy covers all Swizzle websites and related products and services. This summary provides an overview, while the detailed policy constitutes the legal document.</p>
                                        <p>Our Privacy Commitment:</p>
                                        <ul>
                                            <li>Swizzle never sells your information for advertising or displays other people's ads. This commitment has been our foundation since the beginning.</li>
                                            <li>This policy explains what information we collect, how we use it, who can access it, and your control over it.</li>
                                        </ul>
                                    </div>
                                    <ol>
                                        <li>
                                            <h5>Introduction:</h5>
                                            <p>Swizzle Innovations Private Limited ("Swizzle", "we", "our", or "us") is committed to protecting your privacy. This policy outlines how we handle your personal information when you use our software-as-a-service (SaaS) applications and related services (“Services").</p>
                                            <p>By using our Services, you agree to this policy. If you disagree, please don't use our Services.</p>
                                        </li>
                                        <li>
                                            <h5> Information We Collect:</h5>
                                            <ul>
                                                <li>Personal Information: Identifiable information like name, email, phone number, and address.</li>
                                                <li>User Content: Data and information you upload, including text, images, and other materials.</li>
                                                <li>Usage Information: How you use our Services, including IP address, device information, browser type, and operating system.</li>
                                                <li>Cookies and Similar Technologies: We may use cookies to collect information about your interactions with our Services.</li>
                                            </ul>
                    
                                        </li>
                                        <li>
                                            <h5>How We Use Your Information:</h5>
                                            <p>We use the information we collect for various purposes, including:</p>
                                            <ul>
                                                <li>Providing and Improving Services: Deliver, maintain, and improve our Services, including customer and technical support and updates.</li>
                                                <li>Communication: Communicate with you about our Services, updates, and promotional offers.</li>
                                                <li>Analytics: Analyze usage patterns to improve functionality and user experience.</li>
                                                <li>Legal Compliance: Comply with legal obligations and enforce our terms of service.</li>
                                            </ul>
            
                                        </li>
                                        <li>
                                            <h5>Disclosure Of Your Information:</h5>
                                            <ul>
                                                <li>Service Providers: We may share your information with third-party service providers who help us operate and improve our Services. These providers are contractually obligated to protect your information and cannot use it for any other purpose.</li>
                                                <li>Legal Requirements: We may disclose your information if required by law, in response to a court order, or to protect our rights, privacy, safety, or property.</li>
                                                <li>Business Transfers: If Swizzle is merged, acquired, or sells all or part of its assets, your information may be transferred as part of the transaction.</li>
                                            </ul>
                                        </li>
                                        <li>
                                            <h5>Data Security:</h5>
                                            <p>We take reasonable measures to protect your personal information from unauthorized access, disclosure, alteration, or destruction. However, no method is entirely secure, and we cannot guarantee absolute security.</p>
                                        </li>
                                        <li>
                                            <h5>Your Choices:</h5>
                                            <ul>
                                                <li>Access and Update: You can access and update your personal information through your account settings.</li>
                                                <li>Opt-Out: You can opt out of receiving promotional emails from us by following the unsubscribe instructions in those emails.</li>
                                            </ul>
            
                                        </li>
                                        <li>
                                            <h5>Changes To This Privacy Policy:</h5>
                                            <p>We may update this policy to reflect changes in our practices or for other operational, legal, or regulatory reasons. We will notify you of any material changes by posting the revised policy on our website or through other means.</p>
                                        </li>
                                        <li>
                                            <h5>Contact Us:</h5>
                                            <p>If you have any questions or concerns about this policy or our handling of your personal information, please contact us by submitting an <a href="https://swizzleup.com/contact" target="_blank" class="text-decoration-none primary">inquiry here.</a></p>
                                        </li>
                                        <li>
                                            <h5>Jurisdiction:</h5>
                                            <p>This policy is governed by the laws of Kerala, India. Any disputes arising from it shall be subject to the exclusive jurisdiction of the courts in Thiruvananthapuram, Kerala.</p>
                                            <p>By using our Services, you acknowledge that you have read and understood this policy and agree to its terms and conditions.</p>
                                        </li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 text-center mt-3">
                        <small>&copy; {new Date().getFullYear()} SwizzlePay. All rights reserved.</small>

                        </div>
                    </div>
                </div>
            
            </section>
            
            
    </main>
    
</body>
</>
  )
}

export default Privacy